import m from "../../geodata/es2015/ukCountiesHigh";
window.am4geodata_ukCountiesHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/ukCountiesHigh.js
// module id = null
// module chunks = 